import { useIfscService } from "@/services/hooks/ifsc/useIfscServices";
import { useState } from "react";

const useIfscMaster = () => {
  const [isAddIfscModalOpen, toggleIsIfscModalOpen] = useState(false);
  const [isUploadIfscModalOpen, toggleIsUploadIfscModalOpen] = useState(false);

  const {
    services: { getAllIfscService },
    states: { ifscQuery, setIfscQuery },
  } = useIfscService({});

  return {
    services: { getAllIfscService },
    states: {
      ifscQuery,
      setIfscQuery,
      isAddIfscModalOpen,
      toggleIsIfscModalOpen,
      isUploadIfscModalOpen,
      toggleIsUploadIfscModalOpen,
    },
  };
};

export default useIfscMaster;
